'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React from 'react'

// lib
import Box from '@components/kit/box'
import Card, { CardProps } from '@components/kit/card'
import Text from '@components/kit/text'
import { ThemeVariantProvider } from '@components/kit/_support'

/* -----------------------------------------------------------------------------
 * PollAnswerTile
 *
 * The colored card the old kit's Tile drew around each poll answer: a label
 * title in the variant's color, an optional note on the right, and the
 * variant passed down to the fields and buttons inside.
 * -------------------------------------------------------------------------- */

const titleColors = {
  lightGreen: 'everestGreen',
  paleViolet: 'purple'
} as const

export type PollAnswerTileProps = CardProps & {
  children: React.ReactNode
  themeVariant: keyof typeof titleColors
  title: string
  titleRight?: string
}

function PollAnswerTile({
  children,
  themeVariant,
  title,
  titleRight,
  ...rest
}: PollAnswerTileProps) {
  return (
    <ThemeVariantProvider value={themeVariant}>
      <Card
        size='large'
        py='24'
        bg={themeVariant}
        borderRadius='large'
        boxShadow={undefined}
        {...rest}
      >
        <Box>
          <Box flexDirection='row' justifyContent='space-between' mb='08'>
            <Box display='flex' flexDirection='row' alignItems='center'>
              <Text variant='label' textColor={titleColors[themeVariant]}>
                {title}
              </Text>
            </Box>
            <Text variant='small' textColor='shade04'>
              {titleRight}
            </Text>
          </Box>
        </Box>
        {children}
      </Card>
    </ThemeVariantProvider>
  )
}

export default PollAnswerTile
